import UserLayout from "../../components/UserLayout";
import CreateJob from "../../components/user/jobs/CreateJob";

const CreateJobPage = () => {
    return (
        <UserLayout>
            <CreateJob />
        </UserLayout>
    );
}

export default CreateJobPage;